import { KoButton, KoDropdown, KoEmpty, KoFlex, KoForm,  KoLoader, KoModal, KoNano, KoPagination, KoTable, KoText, KoTitle, KoToast, KoTooltips } from "packages";
import KoIcon from '@kwapio/icons';
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import KoToolBar from "shared/components/toolbar";
import { DevelopmentAPI } from "../development.service";
import { LEV_ITEMS_COLUMNS } from './constant';
import Crud from "./crud";
import styles from './module.module.scss';

const Module = (props) => {
  const [totalCount, setTotalCount] = useState(100);
  const [modulesList, setModulesList] = useState();
  const [isOpen, setModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState();
  const [isOpenDelete, setDeleteModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [form] = KoForm.useForm();
  const [pagination, setPagination] = useState({
    size: 100,
    page: 1,
    limit: 100
  });
  const {workspaceId} = useParams();
  const onRow = (record) => {
  };

  useEffect(() => {
    getModules();
  }, []);

  const getModules = () => {
    setModulesList();
    setLoading(true);
    DevelopmentAPI.getModules(pagination, workspaceId).then(
      (data) => {
        setLoading(false);
        setModulesList(data?.modules);
        setTotalCount(data?.totalCount);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const onSearchText = (text) => {
    let q = pagination;
    if (text) {
      q['search'] = text;
    }
    else {
      delete q?.['search'];
    }
    getModules(q);
  };

  const onSort = (key, type) => {
    let q = pagination;
    q['sort'] = `${key}:${type}`;
    getModules(q);
  };

  const onPagination = (page, other) => {
    const query = {
      size: other,
      page: page,
      offset: (page - 1) * other
    };
    const pQuery = Object.assign(pagination, query);
    setPagination(pQuery);
    getModules(pQuery);
  };


  const handleFinish = (values => {
    setLoading(true);
    if (!currentRecord?.moduleId) {
      values['moduleId'] = KoNano('MDL');
    }
    DevelopmentAPI.createOrUpdateModule(values, currentRecord?.moduleId, workspaceId).then(
      (data) => {
        getModules();
        setLoading(false);
        setModal(false);
        form.resetFields();
        KoToast.success("Model created Successfully");

      },

      (err) => {
        setLoading(false);
      }
    );
  });

  const DeleteModules = () => {
    setLoading(true);
    DevelopmentAPI.deleteModule(currentRecord?.moduleId, workspaceId).then(
      (data) => {
        setLoading(false);
        setDeleteModal(false);
        KoToast.success("Modules Deleted Successfully");
        getModules();
      },
      (err) => {
        setLoading(false);
      }
    );
  };





  const items = [
    {
      key: '2',
      danger: true,
      label: 'Delete',
      icon: <KoIcon name='DeleteOutlined' />
    }
  ];

  const onHandelSprint = (e, row) => {
    if (e.key === "2") {
      setDeleteModal(true);
    }
  };
  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 40,
    render: (text, row) => {
      return <div className={`${styles.circle} tableBtn columnsRight`} onClick={() => setCurrentRecord(row)}>
        <KoTooltips title={'Edit'}>
          <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'EditOutlined'} />} onClick={() => setModal(true)} />
        </KoTooltips>
        <div shape="circle">
          <KoDropdown
            menu={{
              items,
              onClick: (e) => onHandelSprint(e, row)
            }}
            overlayClassName={styles.actionDropdown}
            placement="bottomLeft"
          >
            <div shape="circle" >
              <KoIcon name="VerticalMenuOutlined" onClick={() => (row)} />
            </div>
          </KoDropdown>
        </div>
      </div>;
    }
  }];

  
  return (
    <div className={`${styles.wrapper} tableCard`}>
      {isLoading && <KoLoader />}
      
      <KoToolBar
        title={'Modules'}
        search={{ visible: true, onChange: (e) => { onSearchText(e); }, placeholder: 'Search by any parameter' }}
        filter={{ visible: false }}
        buttonList={[{
          label: 'Create',
          type: 'primary',
          icon: <KoIcon color="#FFF" name="PlusOutlined" width={18} height={18} />, onClick: () => setModal(!isOpen)
        }]}
      />
      {modulesList?.length > 0 ? <>
        <KoTable
          rowKey='moduleId'
          onRow={onRow}
          onSort={onSort}
          data={{ columns: LEV_ITEMS_COLUMNS, rows: modulesList }} extraColumnsRight={columnsRight} maxHeight={125} />
        <KoPagination current={parseInt(pagination.page) || 1}
          total={totalCount}
          showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} records`
          }
          pageSize={pagination.limit}
          defaultCurrent={pagination.page}
          onChange={onPagination}
          showQuickJumper={false}
          simple={false}
          responsive={false} />
      </>
        :

        <KoFlex wrap="wrap" gap="small" className={styles.emptySection}>
          <KoEmpty onClick={() => setModal(!isOpen)} label="Create Modules" icon={'EmptyTwoTone'} title="Create a new Modules" />
        </KoFlex>}

      <KoModal
        title={`${currentRecord?.moduleId ? 'Update' : 'Create'} Modules`}
        centered
        open={isOpen}
        afterClose={() => {setCurrentRecord();}}
        handleOk={() => { setCurrentRecord(); setModal(false); }}
        onClose={() => { setCurrentRecord(); setModal(false); }}
        width={580}
        // maskClosable={false}
        height={650}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setModal(!isOpen)} />,
          <KoButton key='create' loading={isLoading} type='primary' label={currentRecord?.moduleId ? `Update` : `Create`}
            onClick={() => form.submit()} />
        ]}
      >
        <Crud form={form} initialValues={currentRecord} handleFinish={handleFinish} />
      </KoModal>

      <KoModal
        title={`Delete ${currentRecord?.name?.toUpperCase()} Modules `}
        centered
        open={isOpenDelete}
        afterClose={() => {setCurrentRecord();}}
        handleOk={() => { setCurrentRecord(); setDeleteModal(false); }}
        onClose={() => { setCurrentRecord(); setDeleteModal(false); }}
        width={580}
        // maskClosable={false}
        height={450}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(!isOpenDelete)} />,
          <KoButton key='delete' loading={isLoading}color="danger" variant="solid"  type='primary' label='Delete' onClick={() => DeleteModules()} />
        ]}
      >
        <div className={styles.delWrapper}>
          <KoTitle level={5} text={`This action will delete item and cannot be undone`} />
          <KoText text={`Do you wish to proceed?`} />
        </div>
      </KoModal>
    </div>
  );
};

export default Module;